import { defineStore } from 'pinia';
import { type Component, ref, shallowRef } from 'vue';

export type ActionModalSize = 'sm' | 'md' | 'lg' | 'xl' | 'full';

export interface ActionModalOptions {
  title: string;
  component: Component | string | null;
  propsData?: Record<string, any>;
  closeOnOverlay?: boolean;
  size?: ActionModalSize;
}

export const useActionModalStore = defineStore('actionModal', () => {
  const isOpen = ref(false);
  const title = ref('');
  const currentComponent = shallowRef<Component | string | null>(null);
  const componentProps = ref<Record<string, any>>({});
  const closeOnOverlay = ref(true);
  const size = ref<ActionModalSize>('lg');

  const open = (options: ActionModalOptions) => {
    title.value = options.title;
    currentComponent.value = options.component;
    componentProps.value = options.propsData || {};
    closeOnOverlay.value = options.closeOnOverlay ?? true;
    size.value = options.size ?? 'lg';
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
    // 延迟清理，让关闭动画播完
    setTimeout(() => {
      currentComponent.value = null;
      componentProps.value = {};
      title.value = '';
      closeOnOverlay.value = true;
      size.value = 'lg';
    }, 300);
  };

  return {
    isOpen,
    title,
    currentComponent,
    componentProps,
    closeOnOverlay,
    size,
    open,
    close,
  };
});
